import type { INotificationItem } from "@src/types/AppTypes";
import { createContext } from "react";

export const NotificationsContext = createContext<{
  notifications: INotificationItem[];
}>({ notifications: [] });

export const NotificationsDispatch = createContext<
  React.Dispatch<
    | {
        payload: INotificationItem[];
        type: "updateNotifications";
      }
    | {
        payload: INotificationItem;
        type: "addNotification";
      }
  >
>(() => {
  throw new Error("No context provider found");
});

export function notificationsReducer(
  state: INotificationItem[],
  action:
    | {
        payload: INotificationItem[];
        type: "updateNotifications";
      }
    | {
        payload: INotificationItem;
        type: "addNotification";
      }
) {
  switch (action.type) {
    case "updateNotifications":
      return action.payload;

    case "addNotification":
      return [action.payload, ...state];

    default:
      return state;
  }
}
